import axios from '../axios'
// 返利策略列表
export const getFinRebatePage = (data) => {
  return axios({
    url: '/api/sys/fin/getFinRebatePage',
    method: 'post',
    data
  })
}
//返利策略列表删除
export const deleteFinRebates = data => {
  return axios({
      url: '/api/sys/fin/deleteFinRebates',
      method: 'post',
      data
  })
};
//充值标准列表保存修改
export const saveFinRebate = data => {
  if (!data.billId) {
    return axios({
        url: '/api/sys/fin/saveFinRebate',
        method: 'post',
        data
    })
  } else {
    return axios({
        url: '/api/sys/fin/updateFinRebate',
        method: 'post',
        data
    })
  }
};


// 返利物料明细列表
export const getFinRebateEntryPage = (data) => {
  return axios({
    url: '/api/sys/fin/getFinRebateEntryPage',
    method: 'post',
    data
  })
}
//返利物料明细列表删除
export const deleteFinRebateEntrys = data => {
  return axios({
      url: '/api/sys/fin/deleteFinRebateEntrys',
      method: 'post',
      data
  })
};
//返利物料明细列表保存
export const saveFinRebateEntry = data => {
  return axios({
      url: '/api/sys/fin/saveFinRebateEntry',
      method: 'post',
      data
  })
};
//返利物料明细列表修改
export const updateFinRebateEntry = data => {
  return axios({
      url: '/api/sys/fin/updateFinRebateEntry',
      method: 'post',
      data
  })
};


// 返利客户明细列表
export const getFinRebatePartnerEntryPage = (data) => {
  return axios({
    url: '/api/sys/fin/getFinRebatePartnerEntryPage',
    method: 'post',
    data
  })
}
//返利客户明细列表删除
export const deleteFinRebatePartnerEntrys = data => {
  return axios({
      url: '/api/sys/fin/deleteFinRebatePartnerEntrys',
      method: 'post',
      data
  })
};
//返利客户明细列表保存
export const saveFinRebatePartnerEntry = data => {
  return axios({
      url: '/api/sys/fin/saveFinRebatePartnerEntry',
      method: 'post',
      data
  })
};
//返利客户明细列表修改
export const updateFinRebatePartnerEntry = data => {
  return axios({
      url: '/api/sys/fin/updateFinRebatePartnerEntry',
      method: 'post',
      data
  })
};


// WEBPACK FOOTER //
// ./src/api/moudules/RebateStrategy.js